



















import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'KETextArea',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    }
  }
});
